// @ts-nocheck
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import {Root as Article_root} from '../blog/article';
import {Editor} from '../../../../../shared/editor/editor';
import {i_article} from '../../../ui/blog/i_blog';
interface i_article_editor_props {
  value: i_article;
  on_change: (v: i_article) => void;
}

export const Article = (props: i_article)=>{
  return <Article_root {...props} />;
};

export const Article_editor = (props: i_article_editor_props)=>{
  const {
    value = {
      title: '',
      img: '',
      preview_bg: '',
      preview_image: '',
      content: '',
      id: '',
      slug: '',
      footer: '',
      excerpt: '',
      time_to_read: '',
      author: {
          name: '',
          img: '',
          position: '',
      },
      seo: {
          title: '',
          description: '',
      },
    },
    on_change,
  } = props;

  type editor_key = keyof i_article;
  type editor_type = 'text' | 'number' | 'boolean' | 'textarea' | 'selector';

  const editors: {key: editor_key; label: string; type: editor_type}[] = [
    {key: 'title', label: 'Title', type: 'text'},
    {key: 'img', label: 'Image URL', type: 'text'},
    {key: 'preview_bg', label: 'Preview Background URL', type: 'text'},
    {key: 'preview_image', label: 'Preview Image URL', type: 'text'},
    {key: 'content', label: 'Content (HTML)', type: 'textarea'},
    {key: 'id', label: 'ID', type: 'text'},
    {key: 'slug', label: 'Slug', type: 'text'},
    {key: 'footer', label: 'Footer (HTML)', type: 'textarea'},
    {key: 'excerpt', label: 'Excerpt', type: 'textarea'},
    {key: 'time_to_read', label: 'Time to Read', type: 'text'},
    {key: 'author.name', label: "Author's Name", type: 'text'},
    {key: 'author.img', label: "Author's Image URL", type: 'text'},
    {key: 'author.position', label: "Author's Position", type: 'text'},
    {key: 'seo.title', label: 'SEO Title', type: 'text'},
    {key: 'seo.description', label: 'SEO Description', type: 'textarea'},
  ];

  return (
    <Editor
      value={value}
      editors={editors}
      on_change={on_change}
      title="Article Editor"
    />
  );
};

